<template>
  <div class="product__instructions product-instructions">
    <template v-for="(item, i) in instructions">
      <div v-if="hasSets" :key="`instruction-${i}`" class="product-instructions__main-title">{{ item.title }}</div>
      <template v-for="(instruction, j) in item.instructions">
        <div
          v-if="instruction.photo"
          :key="`photo-instruction-${i}-${j}`"
          class="product-instructions__img"
        >
          <img
            :src="instruction.photo"
            loading="lazy"
            data-force-load="true"
            :alt="`Інструкція товару «${instruction.title}» - фото №${j}`"
          />
        </div>
        <div v-else :key="`html-instruction-${i}-${j}`" class="product-instructions__text">
          <div class="product-instructions__text-wrap">
            <h2 class="product-instructions__title">
              {{ instruction.title }}
            </h2>
            <div class="product-instructions__info" v-html="instruction.instruction"></div>
          </div>
        </div>
      </template>
      <ProductInstruction
        :title="$t('get_full_instruction')"
        class="product-instructions__file"
        :key="`pdf-${i}`"
        :instruction="getInstruction(item.title)"
      />
    </template>
  </div>
</template>

<script>
import ProductInstruction from '@/components/product/product-page/ProductInstruction'
import { mapState } from 'vuex'
export default {
  name: 'ProductInstructions',
  components: {
    ProductInstruction
  },
  props: {
    instructions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      hasSets: state => state.productInfo.productInfo.hasSets,
      instruction: state => state.productInfo.productInfo.instruction
    })
  },
  methods: {
    getInstruction (productTitle) {
      return this.instruction?.find(instruction => instruction.title === productTitle) || {}
    }
  }
}
</script>

<style scoped lang="sass">

.product-instructions
  display: flex
  flex-flow: column
  align-items: center
  margin-bottom: 30px

  +mmin($tablet)
    flex-flow: row wrap
    margin-bottom: 40px
    justify-content: space-between

.product-instructions__text,
.product-instructions__img
  width: 100%
  text-align: left

  +mmin($tablet)
    width: 50%

.product-instructions__text-wrap
  width: 100%

.product-instructions__main-title
  font-size: 18px
  margin: 40px 0 20px 0
  font-weight: 500
  width: 100%

.product-instructions__title
  font-size: 24px
  font-weight: 400
  margin: 0 0 30px

.product-instructions__info
  color: #4c4c4c
  font-size: 16px
  font-weight: 400
  line-height: 160%

  +mmin($tablet)
    max-width: 500px

.product-instructions__img
  margin-bottom: 30px

  +mmin($tablet)
    margin-bottom: 0

  img
    width: 100%
    display: block

.product-instructions__file
  width: 100%
  margin-top: 20px
</style>
